import { render, staticRenderFns } from "./AppAvatarList.vue?vue&type=template&id=26a68f08&scoped=true&"
import script from "./AppAvatarList.vue?vue&type=script&lang=js&"
export * from "./AppAvatarList.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatarList.vue?vue&type=style&index=0&id=26a68f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a68f08",
  null
  
)

export default component.exports